<nav class="breadcrumbs">
    <ul class="breadcrumbs__list">
        <li class="breadcrumbs__list--item">
            <a [routerLink]="[eRoutes.SLASH, eRoutes.COUNTRIES]">Countries</a>
        </li>
        @for (breadcrumb of breadcrumbs; track $index; let last = $last) {
            <li class="breadcrumbs__list--item"
                [class.breadcrumbs__list--current]="last">
                <mat-icon [svgIcon]="eSvgIcons.ARROW_RIGHT"></mat-icon>
                <a [routerLink]="breadcrumb.path">{{ breadcrumb.text | replaceStr: ' ' }}</a>
            </li>
        }
    </ul>
</nav>

